var configDefault = {
    isDimention: false,
};
var Config = /** @class */ (function () {
    function Config(config) {
        if (config === void 0) { config = configDefault; }
        this.env = config;
    }
    Config.prototype.setConfig = function (newConfig) {
        this.env = newConfig;
    };
    return Config;
}());
export var config = new Config();
